// nav-items.js — DATO, non codice (design §7.2): le viste del monolite Procurement
// per il sottomenù shell (R3). Censimento R0 (evidence shell-r1-r0-openers.txt) +
// case di rerenderView (index.html:16400-16427): 21 voci di navigazione + 5 viste
// detail (PARENT: il detail attiva la voce padre nel sottomenù).
//
// B2.12 (parità 26/26): OGNI id qui sotto DEVE esistere come case di rerenderView
// nel monolite — asserito staticamente da server/src/lib/shell-nav-items.test.js.
// B2.17: NESSUNA label qui — solo glossKey, risolte da client/src/shell/glossary.js.
//
// Ondata 6: le sezioni sono SEMPRE divise e intitolate — anche il gruppo di testa
// (Dashboard + Centro Azioni) ha la sua intestazione 'Panoramica' (il sectionKey
// null resta AMMESSO dal contratto v2 per moduli futuri: la resa mette comunque
// il divisore, semplicemente senza titolo). badge: nome dell'evento bus da cui
// arriva il conteggio (catalogo §4). adminOnly: parità con data-admin-only del monolite.

export const NAV_SECTIONS = [
  {
    sectionKey: 'proc.section.overview',
    items: [
      { id: 'dashboard', glossKey: 'proc.dashboard' },
      { id: 'action-center', glossKey: 'proc.action-center', badge: 'nav:badge' },
    ],
  },
  {
    sectionKey: 'proc.section.sourcing',
    items: [
      { id: 'suppliers', glossKey: 'proc.suppliers' },
      { id: 'conversations', glossKey: 'proc.conversations', badge: 'nav:badge' },
      { id: 'campaigns', glossKey: 'proc.campaigns' },
      { id: 'whatsapp', glossKey: 'proc.whatsapp' },
    ],
  },
  {
    sectionKey: 'proc.section.catalog',
    items: [
      { id: 'products', glossKey: 'proc.products' },
      { id: 'categories', glossKey: 'proc.categories' },
      { id: 'tags', glossKey: 'proc.tags' },
    ],
  },
  {
    sectionKey: 'proc.section.fulfillment',
    items: [
      { id: 'orders', glossKey: 'proc.orders' },
      { id: 'warehouse', glossKey: 'proc.warehouse' },
    ],
  },
  {
    sectionKey: 'proc.section.market',
    items: [
      { id: 'competitors', glossKey: 'proc.competitors' },
      { id: 'monitoring', glossKey: 'proc.monitoring' },
      { id: 'identities', glossKey: 'proc.identities' },
    ],
  },
  {
    sectionKey: 'proc.section.org',
    items: [
      { id: 'conflicts', glossKey: 'proc.conflicts' },
      { id: 'team', glossKey: 'proc.team' },
      { id: 'users', glossKey: 'proc.users', adminOnly: true },
      { id: 'audit', glossKey: 'proc.audit', adminOnly: true },
      { id: 'templates', glossKey: 'proc.templates' },
      { id: 'profile', glossKey: 'proc.profile' },
      { id: 'settings', glossKey: 'proc.settings' },
    ],
  },
];

// Viste detail → voce padre attiva nel sottomenù (design §7.2).
export const PARENT = {
  'supplier-detail': 'suppliers',
  'campaign-detail': 'campaigns',
  'product-detail': 'products',
  'tag-detail': 'tags',
  'order-detail': 'orders',
};

// 21 id di navigazione, nell'ordine di resa.
export const NAV_IDS = NAV_SECTIONS.reduce(
  (acc, s) => acc.concat(s.items.map((it) => it.id)), []
);

// 26 id totali (21 nav + 5 detail): il perimetro della parità B2.12.
export const ALL_VIEW_IDS = NAV_IDS.concat(Object.keys(PARENT));

// nav[] del contratto di registrazione v2 (§3): { section, items[] }.
export function buildNav() {
  return NAV_SECTIONS.map((s) => ({
    section: s.sectionKey,
    items: s.items.map((it) => ({
      id: it.id,
      glossKey: it.glossKey,
      badge: it.badge || null,
      adminOnly: !!it.adminOnly,
    })),
  }));
}
